export default "__VITE_ASSET__DUGR40oN__"